var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.151,
    height: 8.445,
    viewBox: "0 0 10.151 8.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow",
    transform: "translate(10.151 49.791) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232331",
    "data-name": "Group 232331",
    transform: "translate(0 41.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57548",
    "data-name": "Path 57548",
    d: "M9.989,45.174,6.323,41.508a.557.557,0,0,0-.786,0l-.333.333a.551.551,0,0,0-.162.393.562.562,0,0,0,.162.4l2.139,2.143H.548A.542.542,0,0,0,0,45.321v.471a.563.563,0,0,0,.548.57H7.367L5.2,48.517a.55.55,0,0,0,0,.78l.333.332a.557.557,0,0,0,.786,0l3.666-3.666a.56.56,0,0,0,0-.789Z",
    transform: "translate(0 -41.346)",
    fill: "#2d2756"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.518845c597fdb3255b11c6ea980edf4d.svg";
export { ForwardRef as ReactComponent };